var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"space-tree"},[_c('tree',{attrs:{"nodes":_vm.nodes,"setting":_vm.setting},on:{"onClick":_vm.ztreeOnClick,"onCreated":_vm.handleCreated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }